export default {"src":"/_next/static/media/weight.cd5747ca.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};